import React, {Component, SyntheticEvent} from 'react';
import Wrapper from "../Wrapper";
import axios from 'axios';
import {Redirect} from 'react-router-dom';
import {Survey} from "../../classes/survey";

class SurveyEdit extends Component<{ match: any }> {
    state = {
        name : '',
        project_id : '',
        country : '',
        link : '',
        redirect: false
    }
    id = 0;
    name = '';
    project_id = '';
    country = '';
    link = '';

    componentDidMount = async () => {
        this.id = this.props.match.params.id;

        const response = await axios.get(`products/${this.id}`);

        const survey: Survey = response.data.data;

        this.setState({
            name: survey.name,
            project_id: survey.project_id,
            country: survey.country,
            link: survey.link
        })
    }


    submit = async (e: SyntheticEvent) => {
        e.preventDefault();

        await axios.put(`surveys/${this.id}`, {
            name: this.state.name,
            project_id: this.state.project_id,
            country: this.state.country,
            link: this.state.link,
        });

        this.setState({
            redirect: true
        })
    }

    render() {
        if (this.state.redirect) {
            return <Redirect to={'/surveys'}/>;
        }

        return (
            <Wrapper>
                <form onSubmit={this.submit}>
                    <div className="form-group">
                        <label>Name</label>
                        <input type="text" className="form-control" name="name"
                               onChange={e => this.name = e.target.value}
                        />
                    </div>
                    <div className="form-group">
                        <label>Project ID</label>
                        <textarea className="form-control" name="project_id"
                                  onChange={e => this.project_id = e.target.value}
                        ></textarea>
                    </div>
                    <div className="form-group">
                        <label>Country</label>
                        <input type="text" className="form-control" name="country"
                               onChange={e => this.country = e.target.value}
                        />
                    </div>
                    <div className="form-group">
                        <label>Link</label>
                        <input type="text" className="form-control" name="link"
                               onChange={e => this.link = e.target.value}
                        />
                    </div>

                    <button className="btn btn-outline-secondary">Save</button>
                </form>
            </Wrapper>
        );
    }
}

export default SurveyEdit;